import React from 'react';
import Image from './Image';
import Research from '../assets/images/research.svg'
import Venture from '../assets/images/venture.svg'
import SaaS from '../assets/images/saas.svg'
import Line from '@/assets/images/LineShort.svg';

const WeDo = () => {

  return (
    <div className='relative main_container'>
      <div
        data-aos="fade-left"
        data-aos-delay="200"
        data-aos-distance="1500px"
        data-aos-duration="300"
        data-aos-easing="ease-in-out"
      >
        <p className='text-center bg-grad-radial bg-clip-text text-transparent text-[60px] font-bold tracking-[-1.226px]'>What do we do?</p>
        <p className='text-center text-[17px] text-textColor'>We are investing in, building, and contributing to the future of<br/> blockchain solutions, protocols, and enterprises.</p>
      </div>
      <div 
        className='relative z-10 w-full h-[313px] overflow-y-hidden flex items-center justify-center gap-10 mt-10'
        data-aos="fade-left"
        data-aos-delay="500"
        data-aos-distance="1500px"
        data-aos-duration="300"
        data-aos-easing="ease-in-out"
      >
        <div 
          className='w-[334px] h-full bg-grad-custom rounded-2xl border-[1px] border-button-border flex items-center justify-center'
          data-aos="fade-up"
          data-aos-delay="400"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <div className='w-fit'>
            <Image src={Research} className='-mt-8 ml-auto mr-auto' alt='Research' width={234}/>
            <div className='relative px-8 -top-10'>
              <p className='text-center bg-grad-radial bg-clip-text text-[21px] font-extrabold text-transparent tracking-[-1.226px]'>Research</p>
              <p className='text-center text-[14px] text-textColor leading-[15px] mt-2'>Into any of the large number of macro issues crypto has to address before global adoption is a reality.</p>
            </div>
          </div>
        </div>
        <div 
          className='w-[334px] h-full bg-grad-custom rounded-2xl border-[1px] border-button-border'
          data-aos="fade-up"
          data-aos-delay="600"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <Image src={Venture} className='-mt-8 ml-auto mr-auto' alt='Venture' width={234}/>
          <div className='relative px-8 -top-8'>
            <p className='text-center bg-grad-radial bg-clip-text text-[21px] font-extrabold text-transparent tracking-[-1.226px]'>Venture IP</p>
            <p className='text-center text-[14px] text-textColor leading-[15px] mt-3'>Creating our own products for anyone to use such as: open source libraries, exploit prevention tools, and anything else that improves overall developer QOL.</p>
          </div>
        </div>
        <div 
          className='w-[334px] h-full bg-grad-custom rounded-2xl border-[1px] border-button-border'
          data-aos="fade-up"
          data-aos-delay="800"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <Image src={SaaS} className='-mt-5 ml-auto mr-auto' alt='SaaS' width={200}/>
          <div className='relative px-8 -top-3'>
            <p className='text-center bg-grad-radial bg-clip-text text-[21px] font-extrabold text-transparent tracking-[-1.226px]'>SaaS Contracts</p>
            <p className='text-center text-[14px] text-textColor leading-[15px] mt-2'>Ideation, development, and deployment for both web2 & web3 companies.<br/><br/> Complete oversight of all on-chain and off-chain operations.</p>
          </div>
        </div>
      </div>
      <div 
        className='absolute -bottom-[280px] -z-10 flex justify-center w-full'
        data-aos="fade-down"
        data-aos-delay="500"
        data-aos-distance="1500px"
        data-aos-duration="300"
        data-aos-easing="ease-in-out"
      >
        <Image src={Line} className='-mt-8' alt='Line'/>
      </div>
    </div>
    )
}

export default WeDo;